import { AbstractControl } from '@angular/forms';


export const timeValidator =(group: AbstractControl)=>{
    const start = group.value.startTime;
    const end = group.value.endTime;
    if (start !=undefined && end!=undefined && start !='' && end!='' && ((start.getTime() > end.getTime()) ||(start.getTime() ==end.getTime()))) {
        return { 'timeError': true };
    }
    return null;
}

export function avoidEmptyValue(control: AbstractControl) {
    if (control.value!=null && control.value.trim()=='') {
      return { noEmptyValue: true };
    }
    return null;
  }